module.exports = __webpack_public_path__ + "img/symbol_6.f8cd9718.png";